import { Component, Vue } from 'vue-property-decorator'
import { queryClassSummary } from '@/api'
import paperFeedBack from '@/components/paperFeedBack/index.vue'
@Component({ name: 'class-detail-page', components: { paperFeedBack } })
export default class ClassDetailPage extends Vue {
  private queryobj: any = {}
  private classData: any = {}
  created () {
    const obj: any = {
      studentId: this.$route.query.studentId,
      sellOrderId: this.$route.query.sellOrderId,
      classId: this.$route.query.classId
    }
    this.queryobj = obj
    this.initPageData()
  }

  async initPageData () {
    const result: any = await queryClassSummary({ classId: this.$route.query.classId })
    this.classData = result
  }
}
